import React from 'react';

import PropTypes from 'prop-types';

import DropdownAccountMenu from './DropdownAccountMenu/DropdownAccountMenu';
import VerticalAccountMenu from './VerticalAccountMenu/VerticalAccountMenu';

function AccountMenu(props) {
    const {
        isLoggedIn = false,
        onLogOut = () => undefined,
        onMenuToggle = () => undefined,
        userFirstName = '',
        vertical = false,
    } = props;

    if (vertical) {
        return (
            <VerticalAccountMenu
                isLoggedIn={isLoggedIn}
                onLogOut={onLogOut}
                onMenuToggle={onMenuToggle}
                userFirstName={userFirstName}
            />
        );
    }

    return (
        <DropdownAccountMenu
            isLoggedIn={isLoggedIn}
            onLogOut={onLogOut}
            userFirstName={userFirstName}
        />
    );
}

AccountMenu.propTypes = {
    isLoggedIn: PropTypes.bool,
    onLogOut: PropTypes.func,
    onMenuToggle: PropTypes.func,
    userFirstName: PropTypes.string,
    vertical: PropTypes.bool,
};

export default AccountMenu;
